


import { HttpErrorResponse } from '@angular/common/http';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { BigfishPaymentDialogComponent, BigFishWrapper } from '@app/dialogs/bigfish-payment-dialog/bigfish-payment-dialog.component';
import { ChatDialogComponent } from '@app/dialogs/chat-dialog/chat-dialog.component';
import { ExcludedServicesInformationDialogComponent } from '@app/dialogs/excluded-services-information-dialog/excluded-services-information-dialog.component';
import { GenericMessageDialogComponent } from '@app/dialogs/generic-message-dialog/generic-message-dialog.component';
import { SendInvitationDialogComponent } from '@app/dialogs/send-invitation-dialog/send-invitation-dialog.component';
import { SimpleVerificationDialogComponent } from '@app/dialogs/simple-verification-dialog/simple-verification-dialog.component';
import { YesNoDialogComponent } from '@app/dialogs/yes-no-dialog/yes-no-dialog.component';
import { ReservationInfo, Room, RoomGuest } from '@app/dto/ReservationInfo';
import { DocumentReadModes } from '@app/enums/DocumentReadModes';
import ChatVisibilityHelper from '@app/helpers/ChatvisibilityHelper';
import LocalStorage from '@app/helpers/LocalStorage';
import LicenceOptions from '@app/helpers/Options';
import SessionStorage from '@app/helpers/SessionStorage';
import { BigFish } from '@app/interfaces/BigFish';
import { BigFishPayMode } from '@app/interfaces/BigFishPayMode';
import { GenericMessage } from '@app/interfaces/generic-message';
import { BottomBarService } from '@app/services/bottom-bar.service';
import { InvitationEmailService } from '@app/services/invitation-email.service';
import { ReservationService } from '@app/services/reservation.service';
import { SessionstorageService } from '@app/services/sessionstorage.service';
import { GuestStayStatus } from '@app/types/Types';
import { ActiveHoursDialogComponent } from '@globalshared/chat/src/lib/dialog/active-hours/active-hours-dialog.component';
import { ChatService } from '@globalshared/chat/src/lib/services/chat.service';
import { TranslateService } from '@ngx-translate/core';
import dayjs from 'dayjs';
import { Socket } from 'ngx-socket-io';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-check-in-status',
  templateUrl: './check-in-status.component.html',
  styleUrls: ['./check-in-status.component.scss']
})
export class CheckInStatusComponent implements OnInit, AfterViewInit {
  hasExiLicence = LicenceOptions.HasExiLicence
  hasExoLicence = LicenceOptions.HasExoLicence
  isVipTabletMode = LocalStorage.IsVipTabletMode
  rooms: Room[] = SessionStorage.ReservationInfo.Rooms

  completionCounter: string = '';
  public guestStayStatusType: GuestStayStatus;
  contentVisible: boolean = true;
  invited: string;
  messageCounterAfterClose: number = 0
  messageCounter: number = 0
  badgeValue: number = 0
  loaded: boolean;
  constructor(
    private router: Router,
    private bottomBarService: BottomBarService,
    private dialog: MatDialog,
    private genMessageDialog: MatDialog,
    private translate: TranslateService,
    private invitationsService: InvitationEmailService,
    private reservationService: ReservationService,
    private chatService: ChatService,
    public sessionStorageService: SessionstorageService

  ) { }
  ngAfterViewInit(): void {
    this.invited = SessionStorage.Invited;
  }

  ngOnInit() {
    this.bottomBarService.setBottomBarVisibility(true);
    this.calculateCompletion();
    this.refreshReservationInfo();

    this.chatService.customerFacingDataLength.subscribe(data => {
      this.messageCounter = data;

      if (this.messageCounter > this.messageCounterAfterClose) {
        this.badgeValue = this.messageCounter - this.messageCounterAfterClose
      } else {
        this.badgeValue = 0
      }
    })
  }

  openChat() {
    if (this.chatService.isWithin()) {
      let reOpenChat = localStorage.getItem('reOpenChat');
      if (reOpenChat === 'true') {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: true
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
      } else {
        this.dialog.open(ChatDialogComponent, {
          minWidth: '100vw',
          height: '100dvh',
          data: {
            isMinimized: false
          }
        }).afterClosed().subscribe(data => {
          this.badgeValue = 0
          this.messageCounterAfterClose = data
        })
        // this.dialog.open(YesNoDialogComponent, {
        //   disableClose: true,
        //   hasBackdrop: true,
        //   width: "auto",
        //   data: { messageText: this.translate.instant('chat.start_chat_question'), messageType: 'CHAT', showIcon: true }
        // }).afterClosed().subscribe(data => {
        //   if (data) {
        //     this.dialog.open(ChatDialogComponent, {
        //       minWidth: '100vw',
        //       height: '100dvh',
        //       data: {
        //         isMinimized: false
        //       }
        //     }).afterClosed().subscribe(data => {
        //       this.badgeValue = 0
        //       this.messageCounterAfterClose = data
        //     })
        //   }
        // })
      }
    } else {
      this.dialog.open(ActiveHoursDialogComponent, {
        disableClose: true,
        hasBackdrop: true,
        width: "auto",
        data: { messageText: this.translate.instant('chat.non-active-session-title'), messageType: 'WARNING', showIcon: true }
      })
    }
  }

  refreshReservationInfo(): void {

    let tmpResInfo: ReservationInfo = new ReservationInfo()
    let tmpRooms: Room[] = [];
    let roomToAdd: Room = new Room();
    this.reservationService.GetReservationInfo(SessionStorage.GuestStayUuid, SessionStorage.Invited, SessionStorage.ActiveLanguage).subscribe({
      next: (reservationResponse: ReservationInfo) => {
        let res = reservationResponse as ReservationInfo;
        SessionStorage.ReservationInfo = res;
        tmpResInfo = JSON.parse(JSON.stringify(res))
        tmpResInfo.Rooms = [];
        tmpRooms = JSON.parse(JSON.stringify(res.Rooms))
        if (!this.isInvited()) {
          res.Rooms.forEach(reservation => {
            reservation.Guests = reservation.Guests.filter(guest => guest.Status !== GuestStayStatus.CANCELED)
          })
          res.Rooms = res.Rooms.filter(item => item.Guests.length > 0)
          this.rooms = reservationResponse.Rooms
        } else {
          tmpRooms = tmpRooms.filter(item => item.Guests.length > 0)
          tmpRooms.forEach(room => {
            room.Guests = room.Guests.filter(guest => guest.Status !== GuestStayStatus.CANCELED)
            room.Guests.forEach(guest => {
              if (guest.GuestStayUuId == SessionStorage.GuestStayUuid) {
                roomToAdd = room;
              }
            })
          })
          roomToAdd.Guests = roomToAdd.Guests.filter(guest => guest.GuestStayUuId == SessionStorage.GuestStayUuid)
          tmpResInfo.Rooms.push(roomToAdd);
          this.rooms = tmpResInfo.Rooms;
        }
        this.calculateCompletion();
        if (LocalStorage.IsTabletMode && LocalStorage.OperationMode == "VIP" && this.tabletCheckInCompleted()) {
          this.dialog.open(GenericMessageDialogComponent, {
            disableClose: true,
            hasBackdrop: true,
            width: "auto",
            data: { messageText: this.translate.instant('check_in_status.checkin_completed'), messageType: 'INFORMATION' }
          }).afterClosed().subscribe(res => {
            this.router.navigateByUrl('/startcheckin')
          })

        }
        this.loaded = true;
      }
    });
  }


  checkInGuest(guest: RoomGuest, roomId: string) {
    // store selected guest data
    SessionStorage.SelectedGuestData = guest;
    SessionStorage.MrzData = undefined;
    SessionStorage.FaceImageFromCard = '';
    SessionStorage.Selfie = '';
    SessionStorage.RoomId = roomId.toString();

    if (LocalStorage.IsTabletMode) {
      if (LocalStorage.OperationMode == 'VIP') {
        if (SessionStorage.PhotoInTabletMode == DocumentReadModes.DOCUMENT_READ_AND_SELFIE || SessionStorage.PhotoInTabletMode == DocumentReadModes.DOCUMENT_READ_ONLY) {
          this.router.navigateByUrl('/showcheckinsteps')
        } else {
          this.goToVizaDataWithoutPhoto()
        }
      } else {
        if (SessionStorage.PhotoInTabletApp == DocumentReadModes.DOCUMENT_READ_AND_SELFIE || SessionStorage.PhotoInTabletApp == DocumentReadModes.DOCUMENT_READ_ONLY) {
          this.router.navigateByUrl('/showcheckinsteps')
        } else {
          this.goToVizaDataWithoutPhoto()
        }
      }

    } else {
      if (SessionStorage.PhotoInExi == DocumentReadModes.DOCUMENT_READ_AND_SELFIE || SessionStorage.PhotoInExi == DocumentReadModes.DOCUMENT_READ_ONLY) {
        this.router.navigateByUrl('/showcheckinsteps')
      } else {
        this.goToVizaDataWithoutPhoto()
      }
    }

  }

  // Nincs fényképezés: a korválasztás felesleges, rögtön a vizadata jön.
  // Fotó nélkül a GuestAge csak a születési év listáját szűkítené (u14: 15 év), ezért o14 – a teljes lista.
  private goToVizaDataWithoutPhoto() {
    SessionStorage.GuestAge = 'o14';
    this.router.navigateByUrl('/vizadata')
  }

  mustShowCheckState(guest: RoomGuest) {
    if (guest.Status == GuestStayStatus.CHECKED_OUT
      || guest.Status == GuestStayStatus.CHECKED_IN
      || guest.Status == GuestStayStatus.READY_TO_CHECKIN
      || guest.Status == GuestStayStatus.VIZA_VALID
      || guest.Status == GuestStayStatus.VIZA_SUBMITTED) {
      return true
    } else {
      return false
    }
  }

  // VIP tablet módban a recepción már rögzített (VIZA_VALID / READY_TO_CHECKIN) vendég is check-inelhet a tableten
  checkInDisabled(guest: RoomGuest): boolean {
    if (this.isVipTabletMode) {
      return guest.Status == GuestStayStatus.CHECKED_IN
        || guest.Status == GuestStayStatus.CHECKED_OUT
        || guest.Status == GuestStayStatus.CANCELED
    }
    return this.mustShowCheckState(guest)
  }

  // VIP tablet mód: a vendég, akihez a tablet hozzá lett rendelve
  isTabletGuest(guest: RoomGuest): boolean {
    return this.isVipTabletMode && guest.GuestStayUuId == SessionStorage.GuestStayUuid
  }

  invite(guest: RoomGuest) {
    const dialogRef = this.dialog.open(SendInvitationDialogComponent,
      {
        disableClose: true,
        hasBackdrop: true,
        //minWidth: '95%',
        maxWidth: 'auto',
        data: guest
        // height: "350px"
      })
    dialogRef.afterClosed().subscribe(result => {
      let message: string;
      let messageData: GenericMessage;

      if (result) {
        // send invitation
        const res = result as RoomGuest;
        this.invitationsService.sendInvitation(res).subscribe({

          next: (result) => {
            message = this.translate.instant('send_invitation.email_sent').toString();
            messageData = { messageText: message, messageType: 'INFORMATION', showIcon: false }
            const okRef = this.genMessageDialog.open(GenericMessageDialogComponent, {
              disableClose: true,
              hasBackdrop: true,
              minWidth: "auto",
              data: messageData
            })
          },
          error: (err: HttpErrorResponse) => {
            message = this.translate.instant('common.network_error').toString();
            messageData = { messageText: message, messageType: 'ERROR', showIcon: false }
            const okRef = this.genMessageDialog.open(GenericMessageDialogComponent, {
              disableClose: true,
              hasBackdrop: true,
              minWidth: "auto",
              data: messageData
            })
          },
        })
      }
    })
  }


  paymentVisible(guest: RoomGuest) {
    if(!SessionStorage.EnablePayment) {
      return false
    }
    if (LocalStorage.IsTabletMode) {
      return false
    }
    if (!LicenceOptions.HasExoLicence) {
      return false
    } else {
      //Today >= ArrivalDate
      const now = dayjs()
      if (SessionStorage.Invited == "N" && guest.GuestStayUuId == SessionStorage.GuestStayUuid &&  (now.isAfter(guest.Arrival,'day') || now.isSame(guest.Arrival, 'day'))) {
        return true
      } else {
        return false
      }
    }

  }

  paymentAllowed(guest: RoomGuest): boolean {

    if (SessionStorage.Invited == "N") {
      return true
    } else {
      return false
    }
  }

  licenceOk(): boolean {
    if (LicenceOptions.HasExiLicence && !LicenceOptions.HasExoLicence) {
      return true
    }

    if (LicenceOptions.HasExiLicence && LicenceOptions.HasExoLicence) {
      return true
    }

    if (!LicenceOptions.HasExiLicence && LicenceOptions.HasExoLicence) {
      return false
    }


  }

  calculateCompletion() {
    let total: number = 0;
    let checkedIn: number = 0;
    this.rooms.forEach(room => {
      if (this.mustShowRoom(room)) {
        room.Guests.forEach(guest => {
          total += 1;
          if (guest.Status == GuestStayStatus.CHECKED_OUT ||
            guest.Status == GuestStayStatus.CHECKED_IN ||
            guest.Status == GuestStayStatus.READY_TO_CHECKIN ||
            guest.Status == GuestStayStatus.VIZA_VALID ||
            guest.Status == GuestStayStatus.VIZA_SUBMITTED) {
            checkedIn++;
          }
        })
      }

    })
    this.completionCounter = `(${checkedIn}/${total})`
  }

  tabletCheckInCompleted(): boolean {
    let ret: boolean;
    let total: number = 0;
    let checkedIn: number = 0;
    this.rooms.forEach(room => {
      if (this.mustShowRoom(room)) {
        room.Guests.forEach(guest => {
          total += 1;
          // a check-in gomb VIP tablet módban csak CHECKED_IN-nél inaktív, így a befejezés is csak az
          if (guest.Status == GuestStayStatus.CHECKED_IN) {
            checkedIn++;
          }
        })
      }

    })
    return checkedIn == total ? true : false
  }


  paymentClick(guest: RoomGuest, roomId: string) {
    SessionStorage.SelectedGuestData = guest
    SessionStorage.RoomId = roomId;
    this.router.navigateByUrl("/balance?showdeposit=true")

  }

  chatIconStyle() {
    let styles = {};
    styles = ChatVisibilityHelper.ChatVisibleStyle
    return styles
  }

  isLanguageOk(): boolean {
    return SessionStorage.ActiveLanguage == 'hu' ? true : false
  }


  isInvited(): boolean {
    return SessionStorage.Invited == "Y" ? true : false
  }

  showCheckinButton(guest: RoomGuest) {
    if (!LicenceOptions.HasExiLicence) {
      return false
    } else {
      return true
    }
  }
  showInviteButton(guest: RoomGuest) {
    if ((!LicenceOptions.HasExiLicence)) {
      return false
    } else {
      //return true
      if(SessionStorage.Invited == "Y") {
        return false;
      } else {
        return true;
      }
    }
  }
  showMyBillButton() {

  }


  openExcludedServicesDialog() {
    alert("Kivenni")
    this.dialog.open(ExcludedServicesInformationDialogComponent, {
      disableClose: true,
      minWidth: "93vw",
      minHeight: "40vh",
    }).afterClosed().subscribe(result => {
      console.log(result)
    })
  }

  mustShowRoom(room: Room): boolean {
    let found: boolean = false;
    if (SessionStorage.Invited == "Y") {
      room.Guests.forEach(guest => {
        if (guest.GuestStayUuId == SessionStorage.GuestStayUuid) {
          found = true;
          SessionStorage.RoomId = room.RoomId;
        }
      })
      return found;
    } else {
      room.Guests.forEach(guest => {
        if (guest.GuestStayUuId == SessionStorage.GuestStayUuid) {
          SessionStorage.RoomId = room.RoomId;
        }
      })
      return true
    }

    //return found
  }

  getRoomTypeName(room: Room) {
    return room.TypeName == '' ? room.RoomType : room.TypeName

  }
  getAriaLabel() {
    return uuidv4();
  }
}


